import {
  enumIconButtonSizing,
  enumImageIndex,
  kLargeIcon,
  kMediumIcon,
  kSmallIcon,
  kXLargeIcon,
  kXXLargeIcon
} from "../constants";
import { QIconButton } from "./QIconButton";

export class QXIconButton extends QIconButton {
  constructor() {
    super();
    this.fImageMgr = null;
    this.fMinW = null;
    this.fMinH = null;
    this.fImageFile = enumImageIndex.appIcons;
    this.fNumCols = 12;
  }

  InitXIcon(imageMgr, imageFile) {
    this.fImageMgr = imageMgr;
    if (imageFile) this.fImageFile = imageFile;
  }

  SizeElementMinSize(sizeW, sizeH) {
    this.fMinW = sizeW;
    this.fMinH = sizeH;
  }

  AutoSize() {
    var sizeW = this.fMinW;
    var sizeH = this.fMinH;
    var l = this.fLabel;

    if (l != "") {
      var labelLen = this.MeasureLabel() + 6;
      if (labelLen > sizeW) sizeW = labelLen;
    }

    this.SizeElement(sizeW, sizeH);
  }

  DoSetImages(imageRef, sizing, singleImage = false) {
    if (this.fImageFile === enumImageIndex.enableconnectors96) this.fNumCols = 7;
    else if (this.fImageFile == enumImageIndex.viewerIcons) this.fNumCols = 4;

    this.fSrcWidth = 96;
    this.fSrcHeight = 96;
    var iconSize = kLargeIcon;
    switch (sizing) {
      case enumIconButtonSizing.medium:
        iconSize = kMediumIcon;
        break;
      case enumIconButtonSizing.small:
        iconSize = kSmallIcon;
        break;
      case enumIconButtonSizing.xlarge:
        iconSize = kXLargeIcon;
        break;
      case enumIconButtonSizing.xxlarge:
        iconSize = kXXLargeIcon;
        break;
      default:
        break;
    }

    this.fSizing = iconSize;
    this.fDestWidth = this.fSizing.imageWidth;
    this.fDestHeight = this.fSizing.imageHeight;

    if (singleImage === true) {
      var enabledImage = this.fImageMgr.GetIndexImage(imageRef);
      this.fImageFile = enabledImage;
      var disabledImage = enabledImage;
    } else {
      var yOffset = Math.floor(imageRef / this.fNumCols);
      var xOffset = imageRef % this.fNumCols;

      var imageIdx = this.fImageFile;
      var xSpacing = 96;
      var ySpacing = 96;

      var xSize = this.fDestWidth;
      var ySize = this.fDestHeight;

      var enabledImage = this.fImageMgr.GetSubImage(
        imageIdx,
        xOffset,
        yOffset,
        xSize,
        ySize,
        xSpacing,
        ySpacing
      );

      var disabledImage = this.fImageMgr.GetGraySubImage(
        imageIdx,
        xOffset,
        yOffset,
        xSize,
        ySize,
        xSpacing,
        ySpacing
      );
    }

    this.SetEnabledImage(enabledImage);
    this.SetDisabledImage(disabledImage);

    return this.fImageMgr.AddImageElement(
      this.fImageFile,
      imageRef,
      this.fHorzOffset,
      this.fVertOffset,
      this.fSrcWidth,
      this.fSrcHeight,
      this.fDestWidth,
      this.fDestHeight,
      imageIdx === enumImageIndex.viewerIcons
    );
  }
}
